import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=23bc54fe&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=23bc54fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc54fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23bc54fe')) {
      api.createRecord('23bc54fe', component.options)
    } else {
      api.reload('23bc54fe', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=23bc54fe&scoped=true&", function () {
      api.rerender('23bc54fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nc33SeasUK53/JS/comp/PopupDialog.vue"
export default component.exports